import Layout from '@/layout/index.vue';
import { h } from '@vue/composition-api';

export default [
  {
    path: '/boardManage',
    redirect: '/boardManage/formal/board',
  },
  {
    path: '/boardManage/formal',
    component: Layout,
    name: 'boardManage',
    meta: {
      title: '数据运营',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'board',
        name: 'board',
        component: () => import('@/views/boardManage/dataOperation/po_board.vue'),
        meta: { title: 'PO看板', icon: 'el-icon-s-management' },
      },
    ],
  },

  {
    path: '/boardManage/operation',
    component: Layout,
    name: 'boardManageOperation',
    meta: {
      title: '运营看板',
      icon: 'el-icon-s-finance',
      alwaysShow: true, // 即使只有一个子路由也显示父级菜单
    },
    children: [
      {
        path: 'operationAnalysis',
        name: 'operationAnalysis',
        component: () => import('@/views/boardManage/board/analysis.vue'),
        meta: { title: '运营分析', icon: 'el-icon-s-management' },
      },
    ],
  },
];
